module.exports = __webpack_public_path__ + "img/icon-button-x.86e4cc02.svg";